import {createContext} from 'react';
import {User, HexoscopeUser} from './../types';

export const UserContext = createContext({
  user: null as null | User,
  setUser: (user: User | null) => {},
  hexoscopeUser: null as HexoscopeUser | null,
  setHexoscopeUser: (hexoscopeUser: HexoscopeUser | null) => {},
});
